export const events = {
    // Fired once disw.init() has run. Not a signal that the session or region has resolved.
    INIT: 'INIT',
    LOCALES: 'locales',
    ACCOUNT: 'ACCOUNT',
    USER: 'USER',
    BREADCRUMBS: 'BREADCRUMBS',
    ECOMMERCE: 'ECOMMERCE',
    CART: 'CART',
    CONSENT: 'CONSENT',
    COUNTRY: 'COUNTRY',
    REGION: 'REGION',
    REGIONS_DATA: 'REGIONS_DATA',
    DROP_DOWN: 'DROP_DOWN',
    NUMERIC_STEPPER: 'NUMERIC_STEPPER',
    ADDED_TO_CART_MODAL: 'ADDED_TO_CART_MODAL',
    DYNAMIC_KIT_SLIDEOUT: 'DYNAMIC_KIT_SLIDEOUT',
    DYNAMIC_KIT_ADD_TO_CART: 'DYNAMIC_KIT_ADD_TO_CART',
    DYNAMIC_KIT_TERM_CHANGE: 'DYNAMIC_KIT_TERM_CHANGE',
    BASE_KIT_SLIDER: 'BASE_KIT_SLIDEOUT',
    BASE_KIT_OPEN_SLIDEOUT: 'BASE_KIT_OPEN_SLIDEOUT',
    MINI_CART: 'MINI_CART',
    FULL_CART: 'FULL_CART',
    LIVE_CHAT: 'LIVE_CHAT',
    SUBCRIPTION_TERMS_CONFLICT_MODAL: 'SUBSCRIPTION_TERMS_CONFLICT_MODAL',
    VOLUME_BASED_PRICING_MODEL: 'VOLUME_BASED_PRICING_MODEL',
    VISITOR: 'VISITOR',
    TRIAL: 'TRIAL',
    RELATED_RESOURCES: 'RELATED_RESOURCES'
};
const eventMap = new Map();
const eventArgsMap = new Map();
function generateRandomId(event) {
    const randomId = Math.floor(Math.random() * 1000 + 1);
    // Make sure there isn't already an event with the random id.
    if (eventMap.has(event) && eventMap.get(event)?.[randomId]) {
        return generateRandomId(event);
    }
    return randomId;
}
export function emit(event, ...args) {
    if (eventMap.has(event)) {
        for (const callback of Object.values(eventMap.get(event))) {
            const theCallback = callback;
            setTimeout(() => {
                theCallback(...args);
            }, 0);
        }
    }
    eventArgsMap.set(event, args); // Pass the array of args as second parameter to Map.set()
}
/**
 * Registers `callback` for `event` and returns an unsubscribe function.
 *
 * @param event - Event name, one of `events`.
 * @param callback - Called with the emitted args.
 * @param options - Set `{ replay: false }` for events whose args are scoped to
 * a single instance, so only the emitter replays its own last payload.
 * @returns A function removing this subscription.
 */
export function subscribe(event, callback, { replay = true } = {}) {
    const id = generateRandomId(event);
    eventMap.has(event) || eventMap.set(event, {});
    eventMap.get(event)[id] = callback;
    if (replay && eventArgsMap.has(event)) {
        callback(...eventArgsMap.get(event)); // Since the Map holds array of parameters, need to spread that so they are passed as proper parameters
    }
    // return an unsubscribe function
    return function () {
        delete eventMap.get(event)[id];
    };
}
